/**
 * Resuelve el id de rol efectivo para reglas de jerarquía operativa.
 *
 * Si `user.rol.jerarquiaOperativa` tiene valor (p. ej. 4 Cliente, 5 Cadena, 6 Sucursal, 7 Caja),
 * ese valor manda. Si es null/undefined, se usa `user.idRol`.
 *
 * Acepta el objeto de sesión completo (`{ user, token, ... }`) o el `user` interno.
 */
export function getIdRolOperativo(userOrSession: any): number {
  const userInfo = userOrSession?.user ?? userOrSession;
  const jo = userInfo?.rol?.jerarquiaOperativa ?? userInfo?.rol?.JerarquiaOperativa;

  if (jo !== null && jo !== undefined && jo !== '') {
    const n = Number(jo);
    if (Number.isFinite(n)) {
      return n;
    }
  }

  return Number(userInfo?.idRol);
}

export function getIdRolOperativoString(userOrSession: any): string {
  return String(getIdRolOperativo(userOrSession));
}
